import {Pipe, PipeTransform} from '@angular/core';
import { applyCurrencySymbolOverride } from 'src/app/service/currency.util';

@Pipe({
  name: 'dataPropertyGetter'
})
export class DataPropertyGetterPipe implements PipeTransform {

  transform(object: any, keyName: string, currencySymbolOverride?: string): unknown {
    // Per-row money cells come pre-formatted from the backend as "$..."; for plans whose
    // currency resolves to an override (e.g. JMD -> "J$") prefix the "$" so these cells
    // match the client-formatted totals row. Non-currency strings pass through unchanged.
    // (HOA-8305 follow-up)
    return applyCurrencySymbolOverride(object?.[keyName], currencySymbolOverride);
  }

}
